export { HorizontalSeparator, VerticalSeparator, BulletSeparator } from './separator';
